import { Controller } from "stimulus"
import selectize from "selectize"

export default class extends Controller {
  static targets = [ "musicPlaylistIds", "defaultMusicPlaylistIds" ]

  connect() {
    $(this.musicPlaylistIdsTarget).selectize({
      plugins: ['remove_button'],
      allowEmptyOption: true,
      highlight: false,
      preload: true,
      load: this.loadPlaylistIdData.bind(this),
      onItemAdd: this.onItemAdd.bind(this),
      onItemRemove: this.onItemRemove.bind(this)
    })
  }

  loadPlaylistIdData(value, callback) {
    const user_id = this.data.get("user-id")

    $.ajax({
      url: this.data.get("playlists-url").concat(".json"),
      type: "GET",
      data: { q: { user_id, value } },
      success: (data) => {
        callback(data.map(([text, value]) => { return { text, value } }))
      },
      error: callback
    })
  }

  onItemAdd(value, item) {
    const data = this.musicPlaylistIdsTarget.selectize.sifter.items[value]
    this.defaultMusicPlaylistIdsTarget.selectize.addOption(data)
  }

  onItemRemove(value) {
    this.defaultMusicPlaylistIdsTarget.selectize.removeOption(value)
  }
}
